import React from 'react';
import { Box, Typography, FormControlLabel, Radio, RadioGroup, Switch, IconButton } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import { CloseOutlined, LayersOutlined, LocalShippingOutlined, SatelliteAltOutlined } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  layerlabel: {
    color: '#000',
    fontSize: 13,
  }
});

interface Props {
    showDepots: boolean;
    showTouren: boolean;
    selectedBase: string;
    onToggleDepot: () => void;
    onToggleTouren: () => void;
    onChangeBase: (base: string) => void;
    onClose: () => void;
}

export default function LayersPanel({
    showDepots,
    showTouren,
    selectedBase,
    onToggleDepot,
    onToggleTouren,
    onChangeBase,
    onClose,
}: Props) {
    const classes = useStyles();
    return (
        <Box
            sx={{
                position: 'absolute',
                top: 100,
                left: 54,
                zIndex: 1000,
                backgroundColor: '#fff',
                color: '#000',
                padding: '10px 16px',
                borderRadius: 2,
                width: 200,
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography fontWeight="bold">Layers</Typography>
                <IconButton onClick={onClose} size="small" sx={{ color: '#eee' }}>
                    <CloseOutlined />
                </IconButton>
            </Box>

            <Typography variant="caption" color="gray" fontWeight="bold">
                OVERLAYS
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={1}>
                <Box display="flex" alignItems="center" gap={1}>
                    <RoomIcon fontSize="small" />
                    <Typography className={classes.layerlabel}>Depots</Typography>
                </Box>
                <Switch checked={showDepots} onChange={onToggleDepot} color="primary" />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={1}>
                <Box display="flex" alignItems="center" gap={1}>
                    <AltRouteIcon fontSize="small" />
                    <Typography className={classes.layerlabel}>Touren</Typography>
                </Box>
                <Switch checked={showTouren} onChange={onToggleTouren} color="primary" />
            </Box>

            <Box mt={2}>
                <Typography variant="caption" color="gray" fontWeight="bold">
                    BASE LAYERS
                </Typography>
                <RadioGroup
                    value={selectedBase}
                    onChange={(e) => onChangeBase(e.target.value)}
                    name="base-layers"
                >
                    <FormControlLabel
                        value="Standard"
                        control={<Radio color="primary" />}
                        label={<Box display="flex" alignItems="center" gap={1} 
                        className={classes.layerlabel}><LayersOutlined fontSize="small" /> Standard</Box>}
                    />
                    <FormControlLabel
                        value="LKW"
                        control={<Radio color="primary" />}
                        label={<Box display="flex" alignItems="center" gap={1} 
                        className={classes.layerlabel}><LocalShippingOutlined fontSize="small" /> LKW</Box>}
                    />
                    <FormControlLabel
                        value="Satellit"
                        control={<Radio color="primary" />}
                        label={<Box display="flex" alignItems="center" gap={1} 
                        className={classes.layerlabel}><SatelliteAltOutlined fontSize="small" /> Satellit</Box>}
                    />
                </RadioGroup>
            </Box>
        </Box>
    );
}